<header class="w-full bg-white border-b border-gray-200">
    <div class="w-full px-4 sm:px-6 py-3 flex items-center gap-3">
      <!-- Logo placeholder -->
      <div class="w-10 h-10 rounded-lg bg-gray-200 flex items-center justify-center overflow-hidden shrink-0">
        <!-- Replace with your real logo -->
        <a href="https://www.youtube.com/@CuriousResource" target="_blank">
        <img src="assets/logo.jpg" alt="Logo" class="w-full h-full object-cover" />
        </a>
      </div>

      <div class="flex flex-col leading-tight"  *ngIf="header$ | async as header">
        <div class="text-lg sm:text-xl font-bold">
          Curious resource: {{ header['title'] }}
        </div>
        <div class="text-xs sm:text-sm text-gray-500">
          {{ header['slogan'] }}
        </div>
      </div>
    </div>
  </header>
